import { XCircleIcon } from "@heroicons/react/solid";

export default function Danger({ title, msg }) {
  return (
    <div className="rounded-md bg-rose-50 p-4">
      <div className="flex items-center gap-x-2">
        <div className="flex-shrink-0">
          <XCircleIcon className="h-5 w-5 text-rose-400" aria-hidden="true" />
        </div>
        <div className="flex items-center">
          <h3 className="text-sm font-medium text-rose-800">{title}</h3>
          {msg ? <div className="mt-2 text-sm text-rose-700">{msg}</div> : null}
        </div>
      </div>
    </div>
  );
}
